'use strict';
var parent = require('../../es/iterator/every');

module.exports = parent;
